import { CheckIcon } from '@heroicons/react/16/solid';
import { twJoin } from 'tailwind-merge';

type Props = {
  value: boolean;
};

export default function PreferenceCheck({ value }: Props) {
  const defaultClasses = 'w-4 h-4 border';

  const fullClasses = twJoin(
    defaultClasses,
    value ? 'border-zinc-400 fill-primary-600' : 'border-zinc-300 fill-zinc-200',
  );

  return <CheckIcon className={fullClasses} />;
}
